var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6225 8.41025C25.5885 8.24601 24.4727 2.65031 24.4161 2.3558C24.3481 2.04996 24.1273 1.7951 23.8214 1.71014C23.5326 1.62519 23.2098 1.71014 22.9889 1.93103L22.1563 2.74659L19.7436 5.21595L18.7638 6.21275C18.5429 6.43364 18.458 6.75646 18.5429 7.0623C18.6449 7.35115 18.8827 7.57203 19.1886 7.64C19.3585 7.67398 24.9768 9.48635 24.62 9.41272C25.0731 9.56564 25.7471 9.07857 25.6225 8.41025Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9417 21.2954C15.9036 24.6426 9.88875 24.4217 6.11675 20.627C2.14653 16.6398 2.14653 10.1379 6.11675 6.14507C10.1153 2.12387 16.6455 2.11821 20.6554 6.12808C20.7177 6.19038 20.7743 6.24702 20.8309 6.30932L23.0398 4.10049C22.9831 4.03819 22.9208 3.98155 22.8642 3.91925C20.3325 1.3876 16.974 0 13.3946 0C9.82078 0 6.45657 1.39326 3.92492 3.91925C1.39326 6.44524 0 9.81512 0 13.3889C0 16.9627 1.39326 20.3269 3.91925 22.8585C6.44524 25.3902 9.80946 26.7778 13.3889 26.7778C16.5775 26.7778 19.5906 25.6734 22.0033 23.6401C22.4847 23.238 22.5187 22.513 22.0713 22.0656C21.8391 21.8334 21.5899 21.5842 21.369 21.3633C20.9839 20.9782 20.3609 20.9442 19.9417 21.2954Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reload.7721a4f8c1888e2d86344c75fd4bc6de.svg";